export default {
  title:
    'https://mylink.oss-accelerate.aliyuncs.com/paradise/%E4%B8%BB%E6%A8%99%E9%A1%8C-%E7%B9%81%E4%BD%93%402x.png',
  c1: '我的電子券',
  c2: '本月累計簽到',
  c2_1: '天',
  c3: '積分說明',
  c4: '啟用積分碼',
  c5: '任務樂園',
  c5_1: ' ',
  c6: '積分明細',
  c7: '今日簽到',
  c8: '明日簽到',
  c9: '去完成',
  c10: '已完成',
  score109: '本月累計簽到 ',
  score109_1: ' 天',
  score109_2: ' 天',
  score110: '累計簽到7天可獲得額外積分（每月限領一次）',
  score111: '簽到提醒',
  score112: '簽到提醒說明',
  score113:
    '開啓簽到提醒功能後，若本月簽到次數少於3次，系統將會於15號、20號發送簽到提醒通知，關閉則不提醒。',
  score125: '已簽到',
  score126: '今日簽到',
  score127: '雙倍積分',
  score128: '累計簽到滿7日即可獲得額外大獎',
  score129: '立即簽到',
  score130: '簽到成功',
  score131: '+',
  score131_2: '積分',
  score155: '啟⽤積分碼',
  score156: '積分明細',
  score157: '請輸入積分碼',
  score158: '請輸入驗證碼',
  score159: '發送',
  score160: '立即啟用',
  score161: 'MyLink積分碼的條款及細則 ',
  score162:
    '1. MyLink積分碼只適用於使用流動電話號碼註冊MyLink應用程式 (「MyLink」)之MyLink賬號，並不適用於使用家居寬頻號碼註冊之MyLink賬號 (「合資格用戶」)。',
  score163:
    '2. 合資格用戶可通過MyLink活動或MyLink合作商戶中獲得MyLink積分碼，用於兌換MyLink積分。合資格用戶可於MyLink積分碼有效期內，於MyLink「我的積分」à「啟用積分碼」以輸入積分碼及驗證碼（驗證碼將以短訊形式發送至MyLink登入賬號的流動電話號碼）兌換MyLink積分。成功兌換MyLink積分後，合資格用戶可以在MyLink「我的積分」-「積分明細」查詢有關詳情。',
  score164:
    '3. 除非另有規定，每個MyLink積分碼只能使用一次。合資格客戶可於商戶發送MyLink積分碼時所展示之條款及細則查閱其MyLink積分碼之指定兌換有效期。MyLink積分碼必須於指定兌換有效期前，於MyLink兌換成MyLink積分。MyLink積分碼逾期將作廢並自動註銷，且不獲補發或延長兌換有效期。',
  score165:
    '4. 所有MyLink積分碼均不可兌換現金或其他產品或服務，亦不能更換丶退款丶轉售，亦不能與其他優惠同時使用。',
  score166:
    '5. 以MyLink積分碼兌換之MyLink積分使用有效期：每年1月1日至6月30日期間以MyLink積分碼兌換的MyLink積分，將於下一年的6月30日過期；每年7月1日至12月31日MyLink積分碼兌換的MyLink積分將於下一年的12月31日過期。MyLink積分條款及細則詳情請查看',
  score166_link:
    'https://eshop.hk.chinamobile.com/tc/corporate_information/Mylink/mylinkpoints.html。',
  score166_1:
    '6. 任何非本條款及細則的一方的人並不享有第623章《合約(第三者權利)條例》下的權利以執行本條款及細則任何條款或享有本條款及細則任何條款下的權益。',
  score166_2:
    '7. 如法院裁定本條款及細則內任何條款無效或不可強制執行，其餘條款將不受上述無效或不可強制執行影響，並將繼續具十足效力及作用。',
  score166_3:
    '8. 本條款及細則受香港特別行政區法律管轄，而用戶均同意受香港法院的專有審判權所限。',
  score166_4: '9. 如有任何爭議，中國移動香港將保留一切最終決定權。',
  score166_5: '10. 本條款及細則之中英文版本如有歧異，以中文版本為準。',
  score167: '積分碼錯誤',
  score167_1: '積分碼已過期',
  score167_2: '積分碼已使用',
  score167_3: '積分碼已廢棄',
  score168: '驗證碼錯誤',
  score169: '積分',
  score170: '可到積分詳細查看',
  score184: '取消',
  score200: '提提您',
  score201: '您的操作過於頻繁或積分兌換金額過多，請稍後再試。',
  c11: '移動地圖，參觀樂園',
  c12: '雙指放大縮細，參觀樂園',
  c13: '下一步',
  c14: '我知道了',
  c15: '你已分享3次啦，下週再來～',
  c16: '左右滑動, 發掘未完成的任務',
  c17: '網絡異常，請再試',
  c18: '你今日已簽到',
  c19: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/%E6%B5%AE%E7%AA%97-%E7%B9%81%E4%BD%93%402x.png',
  c20: '任務列表',
  c21: '點我開盲盒!',
  c22: '明天再來開盲盒',
  c23: '盲盒中獎記錄',
  c24: '“每日簽到”改成“幸運盲盒日日賞”啦~',
  c25: '快去開盲盒拿驚喜',
  c26: '去開盲盒',
  c27: '「每天簽到」已經升級為「幸運盲盒日日賞」喇, 馬上去開盲盒攞驚喜!',
  c29: '今天還有2次機會',
  c30: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/9.3/tc%402x.png',
  c31: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/9.3/%E6%A0%87%E9%A2%98tc%402x4.png',
  c32: 'https://uatoss.mylinkapp.hk/via/atv/fan-model/index.html?la',
  c33: '金融',
  c34: '保險',
  c35: '證券',
  c36: '匯款',
  c37: '購物',
  c38: '去完成',
  c39: '已完成',
  c40: '已結束',
  c41:'去看看',
  c42:'今日獎勵發完了，明天再來看看吧',
  c43:'當前任務獎勵已領取，看看其他任務吧',
  c44:'好的',
}
